<template>
  <div class="modern-login-wrapper">
    <div v-if="!loading" class="login-page">
      <div class="container">
        <div class="row login-wrapper">
          <div class="col-12 ml-auto mr-auto align-self-center">
            <div class="login-card">
              <!-- Logo Header -->
              <div class="login-header">
                <img src="../../../theme-assets/images/logo/culogo-h.png" class="logo-img" alt="University Logo" />
              </div>
              <b-form class="login-form" @submit.prevent="loginHandler">
                <!-- Username Field -->
                <div class="form-group-modern">
                  <label class="input-label">Application ID</label>
                  <div class="input-wrapper">
                    <i class="fa fa-user input-icon"></i>
                    <b-form-input v-model="form.application_id" type="text" class="modern-input" required
                      placeholder="Enter your Application ID" />
                  </div>
                </div>

                <!-- Password Field -->
                <div class="form-group-modern">
                  <label class="input-label">Password</label>
                  <div class="input-wrapper">
                    <i class="fa fa-lock input-icon"></i>
                    <b-form-input v-model="form.password" type="password" class="modern-input" required
                      placeholder="Enter your password" />
                  </div>
                </div>

                <!-- Remember Me -->
                <div class="remember-row">
                  <b-form-checkbox v-model="form.checked" class="modern-checkbox">
                    Remember me
                  </b-form-checkbox>
                </div>
                <!-- Forgot Password Link -->
                <!-- <b-col class="col-auto my-3 text-center ">
                  <b-link @click="forgotPasswordHandler" class="self-align-end"
                    style="font-size: 12px; cursor:pointer;">
                    <span class="fa fa-lock"></span> Forgot Password?
                  </b-link>
                </b-col> -->


                <!-- <b-col class="col-auto my-3 text-center">
                  <b-link @click="showForgotUsernameModal = true" class="self-align-end mx-2"
                    style="font-size: 12px; cursor:pointer;">
                    <span class="fa fa-user"></span> Forgot Username?
                  </b-link>
                  <b-link @click="forgotPasswordHandler" class="self-align-end mx-2"
                    style="font-size: 12px; cursor:pointer;">
                    <span class="fa fa-lock"></span> Forgot Password?
                  </b-link>
                </b-col> -->

                <!-- <b-modal id="forgot-username-modal" v-model="showForgotUsernameModal" title="Forgot Username" centered
                  hide-footer>
                  <div class="forgot-username-modal p-3">

                    <p class="modal-section-title">Username Format</p>
                    <p class="modal-content mb-2 text-center">
                      <code><strong>[HSC board_code][HSC year][HSC roll]</strong></code>
                    </p>

                    <p class="modal-section-title">Board Codes</p>
                    <table class="board-codes-table mb-2">
                      <thead class="board-codes-thead">
                        <tr>
                          <th>Board Name</th>
                          <th>Board Code</th>
                          <th>Board Name</th>
                          <th>Board Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Dhaka</td>
                          <td>dha</td>
                          <td>Chittagong</td>
                          <td>chi</td>
                        </tr>
                        <tr>
                          <td>Rajshahi</td>
                          <td>raj</td>
                          <td>Barisal</td>
                          <td>bar</td>
                        </tr>
                        <tr>
                          <td>Sylhet</td>
                          <td>syl</td>
                          <td>Comilla</td>
                          <td>com</td>
                        </tr>
                        <tr>
                          <td>Dinajpur</td>
                          <td>din</td>
                          <td>Jessore</td>
                          <td>jes</td>
                        </tr>
                        <tr>
                          <td>Mymensingh</td>
                          <td>mym</td>
                          <td>Technical</td>
                          <td>teh</td>
                        </tr>
                        <tr>
                          <td>Madrasha</td>
                          <td>mad</td>
                        </tr>
                      </tbody>
                    </table>

                    <p class="modal-section-title my-2">Year</p>
                    <p class="modal-content mb-2 small-text px-1">Last two digits of your HSC year.</strong>
                    </p>

                    <p class="modal-section-title my-2">Roll</p>
                    <p class="modal-content mb-2 small-text px-1">Your HSC roll number exactly as on your admit card.
                    </p>

                    <hr class="modal-divider my-2" />

                    <p class="modal-section-title my-2">Example</p>
                    <p class="modal-content small-text"> Dhaka Board, HSC 2025, Roll 123456 becomes <code
                        class="example-code">dha25123456</code></p>

                  </div>

                  <div class="text-center mb-3">
                    <b-button class="login-button w-50" @click="showForgotUsernameModal = false">Go to Log In</b-button>
                  </div>
                </b-modal> -->


                <!-- Login Button -->
                <b-button v-if="!isButtonLoading" type="submit" class="login-button">
                  <i class="fa fa-sign-in"></i> Log In
                </b-button>

                <b-button v-else type="submit" class="login-button loading" disabled>
                  <i class="fa fa-spinner fa-spin"></i> Logging in...
                </b-button>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <loader class="loader"></loader>
    </div>
  </div>
</template>

<script>
import { gce_login } from '../../../utils/Auth'
import Loader from '../../Helper/Loader'

export default {
  name: 'GCELogin',
  components: { Loader },
  data() {
    return {
      loading: true,
      isButtonLoading: false,
      form: {
        application_id: null,
        password: null
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.loading = false
    })
  },
  methods: {
    async loginHandler() {
      this.isButtonLoading = true
      await gce_login(this.form)
      this.isButtonLoading = false
    }
  }
}
</script>

<style scoped>
/* Modern Login Wrapper */
.modern-login-wrapper {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  padding: 20px 0;
}

.login-page {
  width: 100%;
}

.login-wrapper {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Login Card */
.login-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  max-width: 520px;
  width: 100%;
  margin: auto;
  overflow: hidden;
}

/* Login Header */
.login-header {
  text-align: center;
  padding: 50px 30px;
  background: #4e73a8;
}

.logo-img {
  max-width: 90px;
  height: auto;
}

/* Login Form */
.login-form {
  padding: 32px 40px 36px;
}

/* Form Group */
.form-group-modern {
  margin-bottom: 18px;
}

.input-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 6px;
  letter-spacing: 0.2px;
}

/* Input Wrapper */
.input-wrapper {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  font-size: 15px;
  z-index: 1;
}

.modern-input {
  width: 100%;
  padding: 11px 14px 11px 40px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: #fafbfc;
}

.modern-input:focus {
  outline: none;
  border-color: #2c5aa0;
  background: white;
  box-shadow: 0 0 0 3px rgba(44, 90, 160, 0.08);
}

.modern-input::placeholder {
  color: #a0aec0;
  font-size: 13px;
}

/* Remember Me */
.remember-row {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
}

.modern-checkbox {
  font-size: 13px;
  color: #4a5568;
}

/* Login Button */
.login-button {
  width: 100%;
  padding: 11px 20px;
  background: #2c5aa0;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(44, 90, 160, 0.25);
}

.login-button:hover {
  background: #1e4080;
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.35);
}

.login-button:active {
  transform: translateY(1px);
}

.login-button.loading {
  background: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

.login-button.loading:hover {
  background: #94a3b8;
}

.login-button i {
  margin-right: 6px;
  font-size: 13px;
}

/* Forgot Username */
.forgot-username-modal {
  font-size: 0.9rem;
  line-height: 1.5;
  color: #000;
  /* general text color */
}

.modal-section-title {
  font-weight: bold;
  color: #2c5aa0;
  margin-bottom: 0.25rem;
}

.modal-content {
  color: #000;
  margin-bottom: 0.5rem;
}

.board-codes-table {
  width: 100%;
  border-radius: 0px;
}

.board-codes-table td {
  padding: 0px;
  border: 1px solid #696666;
}

.board-codes-table tr td {
  text-align: center;
  padding: 6px 4px;
  font-size: 0.8rem;
}

.modal-divider {
  margin: 0.5rem 0;
  border-top: 1px solid #ccc;
}

.example-code {
  font-weight: bold;
  font-size: 1rem !important;
}

.board-codes-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  color: #000;
}

.board-codes-table th,
.board-codes-table td {
  border: 1px solid #ccc;
  padding: 0.35rem 0.5rem;
  text-align: left;
}

.board-codes-thead {
  background-color: #2c5aa0;
  color: #fff;
}

.board-codes-thead th {
  font-weight: bold;
  text-align: center;
}

.small-text {
  font-size: 0.85rem;
  color: #252525;
  text-align: center;

}


/* Responsive Design */
@media (max-width: 576px) {
  .login-card {
    max-width: 100%;
    border-radius: 12px;
    margin: 0 15px;
  }

  .login-header {
    padding: 35px 20px;
  }

  .logo-img {
    max-width: 70px;
  }

  .login-form {
    padding: 26px 28px 30px;
  }

  .form-group-modern {
    margin-bottom: 16px;
  }

  .modern-input {
    padding: 10px 12px 10px 38px;
    font-size: 13px;
  }

  .input-icon {
    left: 12px;
    font-size: 14px;
  }

  .login-button {
    padding: 10px 18px;
    font-size: 13px;
  }

  .self-align-end {
    color: #007bff;
  }

  .self-align-end:hover {
    text-decoration: underline;
  }
}

/* Smooth animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-card {
  animation: fadeIn 0.4s ease;
}
</style>
